import Add from './Add';
import AffirmLogo from './AffirmLogo';
import Caret from './Caret';
import CasinoIcon from './CasinoIcon';
import CheckMark from './CheckMark';
import Checkbox from './Checkbox';
import CloseIcon from './CloseIcon';
import Compare from './Compare';
import Copy from './Copy';
import Expires from './Expires';
import Favorite from './Favorite';
import FiltersIcon from './FiltersIcon';
import IconArrow from './IconArrow';
import IconPriceCel from './IconPriceCel';
import IconPriceRCI from './IconPriceRCI';
import Phone from './Phone';
import Remove from './Remove';
import Royal from './Royal';
import RoyalLogo from './RoyalLogo';
import SearchIcon from './SearchIcon';
import Share from './Share';
import UnavailableIcon from './UnavailableIcon';
import Warning from './Warning';

export {
	Add,
	AffirmLogo,
	Caret,
	CasinoIcon,
	CheckMark,
	Checkbox,
	CloseIcon,
	Compare,
	Copy,
	Expires,
	Favorite,
	FiltersIcon,
	IconArrow,
	IconPriceCel,
	IconPriceRCI,
	Phone,
	Remove,
	Royal,
	RoyalLogo,
	SearchIcon,
	Share,
	UnavailableIcon,
	Warning,
};
